// Use $ instead of $ without replacing global $
(function ($) {

  $(document).ready(function () {

    // $(".job-positions .details-outer .job-details [class^=col-]").unwrap();

    $(".logo-partners .col").unwrap().unwrap();
    $('.job-positions .details-outer .job-details .cols-1').css({'opacity': 1});
    $('.job-positions .details-outer .job-details h6').css({'opacity': 1});

    $(document).on('change', 'body .job-positions .location-wrapper .location', function (e) {
      var value = $(this).val();
      var value2 = $('.job-positions #views-exposed-form-career-block-1 .form-item-term-node-tid-depth select').val();

      if (value !== value2) {
        $('.job-positions #views-exposed-form-career-block-1 .form-item-term-node-tid-depth select').val(value).trigger('change');
        $('.job-positions #views-exposed-form-career-block-1 .form-submit').trigger('click');
      }
      setTimeout(function () {
        $(".job-positions .details-outer .job-details [class^=col-]").unwrap();
      }, 1000);

      setTimeout(function () {
        $('.job-positions .details-outer .job-details .cols-1').css({'opacity': 1});
        $('.job-positions .details-outer .job-details h6').css({'opacity': 1});
      }, 1500);
    });
  });
  //
  // $(window).on('load', function () {
  //
  //   setTimeout(function () {
  //     $('#views-exposed-form-career-block-1 .form-item-term-node-tid-depth select').val('501').trigger('change');
  //     $('#views-exposed-form-career-block-1 .form-submit').trigger('click');
  //     $(".job-positions .details-outer .job-details [class^=col-]").unwrap();
  //   }, 1500);
  // });

})(jQuery);
